import { matchPath } from 'react-router';

export const isOnPage = (page: string) =>
  !!matchPath(
    { path: page, end: false, caseSensitive: false },
    location.pathname
  );
